/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Comeback_TargetInputs */

const en_portal_goal_comeback_target = /** @type {(inputs: Portal_Goal_Comeback_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A safe return to full training`)
};

const pl_portal_goal_comeback_target = /** @type {(inputs: Portal_Goal_Comeback_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpieczny powrót do pełnego treningu`)
};

/**
* | output |
* | --- |
* | "A safe return to full training" |
*
* @param {Portal_Goal_Comeback_TargetInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_comeback_target = /** @type {((inputs?: Portal_Goal_Comeback_TargetInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Comeback_TargetInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_comeback_target(inputs)
	return en_portal_goal_comeback_target(inputs)
});